import { render } from "./bottombar.vue?vue&type=template&id=06087b58&scoped=true"
import script from "./bottombar.vue?vue&type=script&lang=js"
export * from "./bottombar.vue?vue&type=script&lang=js"

import "./bottombar.vue?vue&type=style&index=0&id=06087b58&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06087b58"]])

export default __exports__